import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: "I've had lower back pain for 11 years. I tried everything. I did the sequence three nights in a row and slept through the night for the first time since 2019. I genuinely cried.",
  name: 'Margaret T.',
  details: '58, London',
  image: 'https://images.unsplash.com/photo-1605405748313-a416a1b84491?w=200&h=200&fit=crop&crop=faces&auto=format'
}, {
  quote: "I was skeptical. I'm a physical therapist and I've seen a lot of back pain 'solutions' that are just recycled content. This is different. The vagus nerve breathing protocol alone is worth 10x the price.",
  name: 'Dr. James R.',
  details: 'Physical Therapist, Toronto',
  image: 'https://randomuser.me/api/portraits/men/52.jpg'
}, {
  quote: "My husband bought this for me because I was waking him up every night shifting around. We're both sleeping better now. Our marriage thanks you.",
  name: 'Sandra K.',
  details: '47, Sydney',
  image: 'https://randomuser.me/api/portraits/women/45.jpg'
}, {
  quote: 'I work a desk job and my lower back has been a disaster for 3 years. The Desk-Side Mini Reset bonus alone changed my workday completely. I do it every 90 minutes and the afternoon pain spike is basically gone.',
  name: 'Carlos M.',
  details: '34, Miami',
  image: 'https://randomuser.me/api/portraits/men/32.jpg'
}, {
  quote: 'At 71, I thought back pain was just part of getting older. The acupressure map in Chapter 5 is something I use every single night now. The difference is remarkable.',
  name: 'Dorothy H.',
  details: '71, Manchester',
  image: 'https://images.unsplash.com/photo-1581579438747-1dc8d17bbce4?w=200&h=200&fit=crop&crop=faces'
}];
export function Testimonials() {
  return <section className="py-24 px-6 bg-navy-800" data-id="element-352">
      <div className="max-w-6xl mx-auto" data-id="element-353">
        <div className="text-center mb-16" data-id="element-354">
          <h2 className="text-4xl md:text-5xl font-serif text-cream mb-4" data-id="element-355">
            What Real People Are Saying
          </h2>
          <div className="flex justify-center gap-1 text-gold-500 mb-4" data-id="element-356">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-current" data-id="element-357" />)}
          </div>
          <p className="text-cream-300/70" data-id="element-358">
            Over 47,000+ people have used the Spine Reset protocol.
          </p>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6" data-id="element-359">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="break-inside-avoid bg-navy-900 border border-navy-700 p-8 rounded-2xl" data-id="element-360">
              <div className="flex gap-1 text-gold-500 mb-4" data-id="element-361">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-362" />)}
              </div>
              <p className="text-cream-300/90 italic mb-6 leading-relaxed" data-id="element-363">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-4" data-id="element-364">
                <img src={t.image} alt={`Portrait of ${t.name}`} className="w-14 h-14 rounded-full object-cover border-2 border-teal-500/30 shadow-md shrink-0" loading="lazy" data-id="element-365" />
                <div data-id="element-366">
                  <p className="font-bold text-cream" data-id="element-367">{t.name}</p>
                  <p className="text-sm text-teal-400" data-id="element-368">{t.details}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}